// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { Field, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import DatePickedField from '../../layout/reduxForm/customFields/DatePickerField';
import TimePickedField from '../../layout/reduxForm/customFields/TimePickerField';
import InputField from '../../layout/reduxForm/customFields/InputField';
import { endDateFilter, startDateFilter } from '../../../utils/pickerDateFilters';
import Notification from "../../notification";

const specialCharRegex = /^[a-zA-Z0-9\s.,'-]*$/;

// --- Validation helpers ---
const validateNoSpecialChars = (value, fieldName) => {
    if (!value) return undefined;
    const isValid = specialCharRegex.test(value);
    if (!isValid) {
        Notification('warning', { message: `${fieldName} contains special characters!` });
        return 'Special characters are not allowed';
    }
    return undefined;
};

const createWorkOrderReduxFormSelector = formValueSelector('createWorkOrderReduxForm');

const DateSection = ({ startDate }) => (
    <div className="fields_group">
        {/* Date fields */}
        <div className="field_col">
            <label className="field_name" htmlFor="date_start">
                Date*
            </label>
            <div className="field_block">
                <Field
                    type="date"
                    name="startDate"
                    id="date_start"
                    placeholder="Start Date"
                    filterDate={startDateFilter}
                    component={DatePickedField}
                />
            </div>

            <div className="field_block">
                <Field
                    type="date"
                    name="endDate"
                    id="date_end"
                    placeholder="End Date"
                    filterDate={(date) => endDateFilter(date, startDate)}
                    component={DatePickedField}
                />
            </div>
        </div>

        {/* Time fields */}
        <div className="field_col">
            <label className="field_name" htmlFor="time">
                Time*
            </label>
            <div className="field_block">
                <Field
                    name="startTime"
                    id="time_start"
                    component={TimePickedField}
                />
            </div>
            <div className="field_block">
                <Field
                    name="endTime"
                    id="time_end"
                    component={TimePickedField}
                />
            </div>
        </div>

        {/* Site ID */}
        <div className="field_col">
            <label className="field_name" htmlFor="site_id">
                Site ID*
            </label>
            <div className="field_block">
                <Field
                    name="siteId"
                    id="site_id"
                    placeholder="Site ID"
                    maxLength={50}
                    component={InputField}
                    // validate={[validateNoSpecialChars]}
                />
            </div>
        </div>

        {/* Site Name */}
        <div className="field_col">
            <label className="field_name" htmlFor="site_name">
                Site Name*
            </label>
            <div className="field_block">
                <Field
                    name="siteName"
                    id="site_name"
                    placeholder="Site Name"
                    maxLength={50}
                    component={InputField}
                    // validate={[validateNoSpecialChars]}
                />
            </div>
        </div>
    </div>
);

const mapStateToProps = (state) => ({
    startDate: createWorkOrderReduxFormSelector(state, 'startDate'),
});

export default connect(mapStateToProps)(React.memo(DateSection));
